export default "__VITE_ASSET__CD2o$MSv__"